import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Layout from "./components/Layouts";
import Home from "./containers/Home";
import MyComponent from "./containers/Home/MyComponent";
import Profile from "./containers/Profile";
import StudentProfile from "./containers/StudentContainer/Profile";
import ApplicationHome from "./containers/ApplicationContainer/ApplicationHome";
import ApplicationDetail from "./containers/ApplicationContainer/ApplicationDetail";

import ApplicationProfile from "./components/Application/ApplicationProfile";
import ApplicationPage from "./components/Application/ApplicationPage/index";
import Error from "./components/404Page";
import Login from "./containers/Login";
import Register from "./containers/Register";
import ClassPage from "./containers/StudentContainer";
import FacultyClassPage from "./containers/FacultyContainer";
import SelectClass from "./containers/StudentContainer/selectClass";
import CourseCatalog from "./containers/CourseCatalog";
import Documents from "./containers/Documents";
import Checkout from "./components/Students/SelectClass/Checkout";
import AdmissionTest from "./containers/Admission Test";
import Grades from "./containers/Grades";
import PaymentPage from "./components/Students/SelectClass/Checkout/paymentPage";
import InterviewSlection from "./components/Prospective/InterviewSelection/";
import Attendance from "./containers/FacultyContainer/Attendance";
import PaymentHit from "./components/Prospective/Payment/PaymentHit";
import PaymentTest from "./components/Payment/";
import DegreePlan from "./containers/StudentContainer/DegreePlan";
import AttendaceReport from "./containers/FacultyContainer/AttendacnceReport";
import TestAndScore from "./containers/FacultyContainer/TestAndScores";
import OpportunitiesPage from "./containers/Alumni/Opportunities";
import EventPage from "./containers/Alumni/Event";
import SchedulePage from "./containers/StudentContainer/Schedule";
import Invoices from "./components/Invoices/index";
import { formatDateTime } from "./utils/general";

const studentprofileRequiredFields = {
  primaryDetails: {
    studentId:{
      required: true,
      disabled: true,
    },
    emailaddress1: {
      required: true,
      disabled: true,
    },
    firstname: {
      required: true,
      disabled: true,
    },
    middlename: {
      required: true,
      disabled: true,
    },
    lastname: {
      required: true,
      disabled: true,
    },
    suffix: {
      required: true,
      disabled: true,
    },
    birthdate: {
      required: true,
    },
    gender: {
      disabled: true,
    },
  },
  contact: {
    mobilephone: {
      required: false,
    },
    telephone1: {
      required: true,
    },
    skypeId: {
      required: true,
    },
  },
  HomeAddress: {
    address1_country: {
      required: true,
      disabled: false,
    },
    address1_line1: {
      required: true,
      disabled: false,
    },
    address1_city: {
      required: true,
      disabled: false,
    },
    address1_stateorprovince: {
      required: true,
      disabled: false,
    },
    address1_postalcode: {
      required: true,
      disabled: false,
    },
  },
  mailingAddress: {
    address2_country: {
      required: true,
      disabled: true,
    },
    address2_line1: {
      required: true,
      disabled: true,
    },
    address2_city: {
      required: true,
      disabled: true,
    },
    address2_stateorprovince: {
      required: true,
      disabled: true,
    },
    address2_postalcode: {
      required: true,
      disabled: true,
    },
  },
  billingAddress: {
    address3_country: {
      required: true,
      disabled: true,
    },
    address3_line1: {
      required: true,
      disabled: true,
    },
    address3_city: {
      required: true,
      disabled: true,
    },
    address3_stateorprovince: {
      required: true,
      disabled: true,
    },
    address3_postalcode: {
      required: true,
      disabled: true,
    },
  },
  emergenencyContact: {
    name: {
      required: true,
    },
    relationship: {
      required: true,
    },
    phone: {
      required: true,
    },
  },
};
const myInfoRequiredFields = {
  primaryDetails: {
    emailaddress1: {
      required: true,
      disabled: true,
    },
    firstname: {
      required: true,
      disabled: true,
    },
    middlename: {
      required: true,
      disabled: true,
    },
    lastname: {
      required: true,
      disabled: true,
    },
    suffix: {
      required: true,
      disabled: true,
    },
    birthdate: {
      required: true,
    },
    gender: {
      disabled: true,
    },
  },
  contact: {
    mobilephone: {
      required: false,
    },
    telephone1: {
      required: false,
    },
    skypeId: {
      required: false,
    },
  },
  HomeAddress: {
    address1_country: {
      required: true,
    },
    address1_line1: {
      required: true,
    },
    address1_city: {
      required: true,
    },
    address1_stateorprovince: {
      required: true,
    },
    address1_postalcode: {
      required: true,
    },
  },
  mailingAddress: {
    address2_country: {
      required: false,
    },
    address2_line1: {
      required: false,
    },
    address2_city: {
      required: false,
    },
    address2_stateorprovince: {
      required: false,
    },
    address2_postalcode: {
      required: false,
    },
  },
  emergenencyContact: {
    name: {
      required: false,
    },
    relationship: {
      required: false,
    },
    phone: {
      required: false,
    },
  },
};

function App() {
  const isLoggedIn = (props) => {
    if (window.localStorage.getItem("x-auth-token") == null) {
      return false;
    } else {
      return true;
    }
  };

  console.log("Current Date and Time :",formatDateTime() )
  return (
    <Layout>
      <Switch>
        <Route path="/login" exact component={Login} />
        <Route path="/register" exact component={Register} />
        <Route
          path="/home"
          exact
          render={(props) =>
            isLoggedIn(props) ? <Home {...props} /> : <Redirect to="/login" />
          }
        />
        <Route
          path="/prospective/admission-test"
          exact
          render={(props) =>
            isLoggedIn(props) ? (
              <AdmissionTest {...props} />
            ) : (
              <Redirect to="/login" />
            )
          }
        />
        <Route
          path="/prospective/interview-selection"
          exact
          render={(props) =>
            isLoggedIn(props) ? (
              <InterviewSlection {...props} />
            ) : (
              <Redirect to="/login" />
            )
          }
        />
        <Route
          path="/prospective/payment"
          exact
          render={(props) =>
            isLoggedIn(props) ? (
              <PaymentHit {...props} />
            ) : (
              <Redirect to="/login" />
            )
          }
        />
        <Route
          path="/payment"
          exact
          render={(props) =>
            isLoggedIn(props) ? <PaymentTest /> : <PaymentTest />
          }
        />
        <Route
          path="/students/classes"
          exact
          render={(props) =>
            isLoggedIn(props) ? (
              <ClassPage {...props} />
            ) : (
              <Redirect to="/login" />
            )
          }
        />
        <Route
          path="/students/select-class"
          exact
          render={(props) =>
            isLoggedIn(props) ? (
              <SelectClass {...props} />
            ) : (
              <Redirect to="/login" />
            )
          }
        />
         <Route path="/MonUSB-2023-USB-pageHTML.html">
          <MyComponent />
        </Route>

        <Route
          path="/coursecatalog"
          exact
          render={(props) =>
            isLoggedIn(props) ? (
              <CourseCatalog {...props} />
            ) : (
              <Redirect to="/login" />
            )
          }
        />

        <Route
          path="/documents"
          exact
          render={(props) =>
            isLoggedIn(props) ? (
              <Documents {...props} />
            ) : (
              <Redirect to="/login" />
            )
          }
        />
        <Route
          path="/students/select-class/checkout"
          exact
          render={(props) =>
            isLoggedIn(props) ? (
              <Checkout {...props} />
            ) : (
              <Redirect to="/login" />
            )
          }
        />
        <Route
          path="/students/select-class/checkout/payment"
          exact
          render={PaymentPage}
        />
        <Route
          path="/students/grades"
          exact
          render={(props) =>
            isLoggedIn(props) ? <Grades {...props} /> : <Redirect to="/login" />
          }
        />
        <Route
          path="/account"
          exact
          render={(props) =>
            isLoggedIn(props) ? (
              <Invoices {...props} />
            ) : (
              <Redirect to="/login" />
            )
          }
        />
          <Route
          path="/prospective/landingpage"
          exact
          render={(props) =>
            isLoggedIn(props) ? (
              <ApplicationHome
                {...props}
                title="Application"
              />
            ) : (
              <Redirect to="/login" />
            )
          }
        />
           <Route
          path="/prospective/detail/:applicantId/:applicationId"
          exact
          render={(props) =>
            isLoggedIn(props) ? (
              <ApplicationDetail
                {...props}
                title="Application Detail"
              />
            ) : (
              <Redirect to="/login" />
            )
          }
        />
          <Route
          path="/prospective/profile"
          exact
          render={(props) =>
            isLoggedIn(props) ? (
              <ApplicationProfile
                {...props}
                title="Application Profile"
              />
            ) : (
              <Redirect to="/login" />
            )
          }
        />
         <Route
          path="/prospective/application"
          exact
          render={(props) =>
            isLoggedIn(props) ? (
              <ApplicationPage
                {...props}
                title="Application Initial Agreement"
              />
            ) : (
              <Redirect to="/login" />
            )
          }
        />
         <Route
          path="/prospective/application/:applicantId/:applicationId"
          exact
          render={(props) =>
            isLoggedIn(props) ? (
              <ApplicationPage
                {...props}
                title="Application Initial Agreement"
              />
            ) : (
              <Redirect to="/login" />
            )
          }
        />
         <Route
          path="/students/profile"
          exact
          render={(props) =>
            isLoggedIn(props) ? (
              <StudentProfile
                {...props}
                title="Student"
                fields={studentprofileRequiredFields}
              />
            ) : (
              <Redirect to="/login" />
            )
          }
        />
        <Route
          path="/students/degree"
          exact
          render={(props) =>
            isLoggedIn(props) ? (
              <DegreePlan {...props} />
            ) : (
              <Redirect to="/login" />
            )
          }
        />
        <Route
          path="/alumni/profile"
          exact
          render={(props) =>
            isLoggedIn(props) ? (
              <Profile
                {...props}
                title="Alumni"
                fields={myInfoRequiredFields}
              />
            ) : (
              <Redirect to="/login" />
            )
          }
        />
        <Route
          path="/students/schedule"
          exact
          render={(props) =>
            isLoggedIn(props) ? (
              <SchedulePage {...props} />
            ) : (
              <Redirect to="/login" />
            )
          }
        />
        <Route
          path="/alumni/opportunities"
          exact
          render={(props) =>
            isLoggedIn(props) ? (
              <OpportunitiesPage {...props} />
            ) : (
              <Redirect to="/login" />
            )
          }
        />
        <Route
          path="/alumni/events"
          exact
          render={(props) =>
            isLoggedIn(props) ? (
              <EventPage {...props} />
            ) : (
              <Redirect to="/login" />
            )
          }
        />
        {/* <Route
          path="/events"
          exact
          render={(props) =>
            isLoggedIn(props) ? (
              <EventPage {...props} />
            ) : (
              <Redirect to="/login" />
            )
          }
        /> */}
        <Route
          path="/faculty/attendancereport"
          exact
          render={(props) =>
            isLoggedIn(props) ? (
              <AttendaceReport {...props} />
            ) : (
              <Redirect to="/login" />
            )
          }
        />
        <Route
          path="/faculty/profile"
          exact
          render={(props) =>
            isLoggedIn(props) ? (
              <Profile {...props} />
            ) : (
              <Redirect to="/login" />
            )
          }
        />
        <Route
          path="/faculty/classes"
          exact
          render={(props) =>
            isLoggedIn(props) ? (
              <FacultyClassPage {...props} />
            ) : (
              <Redirect to="/login" />
            )
          }
        />
        <Route
          path="/faculty/attendance"
          exact
          render={(props) =>
            isLoggedIn(props) ? (
              <Attendance {...props} />
            ) : (
              <Redirect to="/login" />
            )
          }
        />
        <Route
          path="/faculty/testandscore"
          exact
          render={(props) =>
            isLoggedIn(props) ? (
              <TestAndScore {...props} />
            ) : (
              <Redirect to="/login" />
            )
          }
        />
        <Route
          path="/parents/profile"
          exact
          render={(props) =>
            isLoggedIn(props) ? (
              <Profile
                {...props}
                title="Alumni"
                fields={myInfoRequiredFields}
              />
            ) : (
              <Redirect to="/login" />
            )
          }
        />
        <Route path="/" exact>
          <Redirect to="/home" />
        </Route>
        <Route path="*" component={Error} />
      </Switch>
    </Layout>
  );
}

export default App;
